/** Trigger a client-side download of a text file (e.g. a Markdown report). */
export function downloadText(
  name: string,
  text: string,
  mime = 'text/markdown;charset=utf-8',
): void {
  const blob = new Blob(['﻿' + text], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

/** Build an Excel-friendly CSV (UTF-8 BOM) and trigger a client-side download. */
export function downloadCsv(name: string, rows: unknown[][]): void {
  const cell = (v: unknown): string => {
    let s = v == null ? '' : String(v);
    // CSV formula-injection defence (OWASP): a cell that STARTS with = + - @ (or a tab/CR lead-in) is
    // evaluated as a formula by Excel/Sheets — a customer named `=cmd|'/c ...'` would execute on open.
    // Prefix a `'` so it's forced to text, EXCEPT for plain numbers (e.g. "-5000"), which must stay numeric.
    if (/^[=+\-@\t\r]/.test(s) && !/^-?\d+(\.\d+)?$/.test(s)) s = `'${s}`;
    return /["\n\r,]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = '\uFEFF' + rows.map((r) => r.map(cell).join(',')).join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${name}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
